import { render, staticRenderFns } from "./pushIndex.vue?vue&type=template&id=73dde885&"
import script from "./pushIndex.vue?vue&type=script&lang=js&"
export * from "./pushIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pushIndex.vue"
export default component.exports